module.exports = __webpack_public_path__ + "static/media/rambu pele 2WEB.59ac8da3.jpg";